<template>
	<div
		id="chassisView"
		:class="{ animate: animateView }"
		:style="{ 'animation-delay': animationDelay }"
		class="content-container carousel-view"
	>
		<Carousel
			:animate="animate"
			:items="pilots"
			:roster-image="p => (p.mech ? p.mech.art : '/nodata-mech.png')"
			:roster-label="p => p.callsign"
			:roster-title="p => (p.mech ? p.mech.name : '—')"
			fallback-image="/nodata-mech.png"
			:max-card-height="740"
			empty-text="// NO CHASSIS RECORDS ON FILE //"
			v-slot="{ item }"
		>
			<MechCard :pilot="item" />
		</Carousel>
	</div>
</template>

<script>
import Carousel from "@/components/Carousel.vue";
import MechCard from "@/components/MechCard.vue";

export default {
	components: {
		Carousel,
		MechCard,
	},
	props: {
		animate: {
			type: Boolean,
			required: true,
		},
		pilots: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			animateView: this.animate,
			animationDelay: "0s",
		};
	},
};
</script>
